import {useState} from "react";
import {bookingAPI} from "../common/api/bookingAPI";
import {API_CURRENCY_CONVERSION} from "../common/api/apiConstants";

export const useCurrencyConversion = () => {

    const [loadingCurrencyConversion, setLoadingCurrencyConversion] = useState(false);
    const [errorCurrencyConversion, setErrorCurrencyConversion] = useState(null);
    const [data, setData] = useState();

    const getCurrencyConversion = (toConvertPayload) => {
        setLoadingCurrencyConversion(true);
        setErrorCurrencyConversion(null);

        return bookingAPI.post(API_CURRENCY_CONVERSION, toConvertPayload)
            .then(res => res.data)
            .then(res => {
                setLoadingCurrencyConversion(false);
                setData(res);
                return res;
            })
            .catch(err => {
                setLoadingCurrencyConversion(false);
                setErrorCurrencyConversion(err);
                throw err;
            });
    };

    return {
        getCurrencyConversion,
        conversionResults: data,
        loadingCurrencyConversion,
        errorCurrencyConversion
    };
};
